<template>
    <div class="gm-info-window">
        <div class="image" :style="'background-image: url(' + (image ? image : '/assets/images/backgrounds/new-york.jpg') + ')'"></div>
        <div class="info">
            <span class="title">{{ title }}</span>
            <span v-if="address" class="address">{{ address }}</span>
            <span v-if="phone" class="phone">
                <a :href="'tel:' + phone">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.8766 9.1894C12.0195 9.1894 11.1779 9.05534 10.3804 8.79178C9.98958 8.65849 9.50917 8.78077 9.27066 9.02573L7.6965 10.2141C5.87092 9.23956 4.7464 8.11541 3.78521 6.30354L4.93857 4.77039C5.23822 4.47114 5.3457 4.03401 5.21693 3.62385C4.95224 2.82213 4.81779 1.98093 4.81779 1.12343C4.81782 0.503964 4.31386 0 3.69443 0H1.12339C0.503964 0 0 0.503964 0 1.12339C0 8.22365 5.77638 14 12.8766 14C13.4961 14 14 13.496 14 12.8766V10.3127C14 9.69336 13.496 9.1894 12.8766 9.1894Z"
                        fill="#00E391"/>
                </svg> {{ phone }}
                </a>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "GoogleMapInfoWindow",
    props: {
        title: {
            default: null
        },
        image: {
            default: null
        },
        address: {
            default: null
        },
        phone: {
            default: null
        }
    }
}
</script>

<style scoped>

</style>
